const ScoreParecerInteligenteI18n = {
  header: {
    title: 'Parecer inteligente Sankhya Score',
    badgeIa: 'IA',
    badgeBeta: 'Beta',
    subtitle: 'Análise gerada automaticamente a partir dos dados de bureaus e do ERP.',
    infoTooltip: 'Esta análise é gerada por IA e pode conter erros. Antes de tomar qualquer decisão de crédito, revise todas as informações. Este parecer é apenas uma recomendação.',
    collapseBtn: 'Recolher parecer',
    expandBtn: 'Expandir parecer',
  },
  loading: {
    label: 'Gerando parecer inteligente...',
  },
  unavailable: {
    title: 'Parecer temporariamente indisponível.',
    text: 'Os dados da consulta estão completos e disponíveis abaixo. Selecione Atualizar consulta para tentar gerar o parecer novamente.',
  },
  partial: {
    title: 'Análise parcial.',
    text: 'A consulta retornou poucos indicadores. O parecer abaixo cobre apenas os dados disponíveis e pode não refletir o risco completo.',
  },
  risk: {
    label: 'Risco avaliado',
    low: 'Risco baixo',
    medium: 'Risco médio',
    high: 'Risco alto',
  },
  confidence: {
    label: 'Confiança da análise',
    tooltip: 'Alta: dados completos de bureaus e ERP. Média: dados parciais. Baixa: poucos indicadores disponíveis.',
    high: 'Alta',
    medium: 'Média',
    low: 'Baixa',
  },
  lists: {
    positives: 'Pontos positivos',
    attention: 'Pontos de atenção',
    recommendation: 'Recomendação da IA',
  },
  decision: {
    approve: 'Aprovação recomendada',
    approveWithCaution: 'Aprovação com cautela',
    reject: 'Reprovação recomendada',
  },
  disclaimer: 'Esta análise é gerada por IA e pode conter erros. Antes de tomar qualquer decisão de crédito, revise todas as informações. Este parecer é apenas uma recomendação.',
};

export default ScoreParecerInteligenteI18n;
